module.exports = "/images/label-tags-icon.svg?311f1866dcabeec5ef33f350bc045ddc";